/**
 * Provides the basic app state and routing
 */

import React, {Component} from 'react';
import './App.css';

import {BrowserRouter, Route} from 'react-router-dom';
import injectTapEventPlugin from 'react-tap-event-plugin'
import Homepage from './Homepage';
import Editor from './Editor';

import {createStore} from 'redux';
import {devToolsEnhancer} from 'redux-devtools-extension';
import {Provider} from "react-redux";
import {reduxStore} from "./state/";
import {AppBar, IconButton, MuiThemeProvider} from "material-ui";
import LeftNav from "./components/LeftNav";
import {NavigationMenu} from "material-ui/svg-icons/index";
import {blue500} from "material-ui/styles/colors";

let store = createStore(reduxStore, devToolsEnhancer());
injectTapEventPlugin();

class App extends Component {
  constructor(props) {
    super(props);
  
    console.log(process.env);
    this.state = {
      navigationVisible: false,
      navigationPinned: false,
      appTitle: "Homepage",
    }

    this.handleNavigationVisibility = this.handleNavigationVisibility.bind(this);
    this.handleToggleNavigation = this.handleToggleNavigation.bind(this);
  }
  
  handleNavigationVisibility(show) {
    this.setState({navigationVisible: show})
  };
  
  handleToggleNavigation() {
    this.setState({navigationVisible: !this.state.navigationVisible});
  };
  
  render() {
    return (
      <Provider store={store}>
        <BrowserRouter>
          <MuiThemeProvider>
            <div>
              <AppBar
                iconElementLeft={<IconButton onTouchTap={this.handleToggleNavigation}><NavigationMenu/></IconButton>}
                // title={this.state.appTitle}
                style={{
                  position: "fixed",
                  top: 0,
                  boxShadow: "none",
                  backgroundColor: blue500,
                }}
              />
              <LeftNav
                pinned={this.state.navigationPinned}
                open={this.state.navigationVisible}
                handleChange={this.handleNavigationVisibility}
              />
              <div
                style={{
                  height: "calc(100vh - 64px)",
                  width: this.state.navigationPinned && this.state.navigationVisible ? "calc(100vw - 256px)" : "100vw",
                  top: "64px",
                  position: "fixed",
                  transform: this.state.navigationPinned && this.state.navigationVisible ? "translate(256px, 0px)" : "translate(0px, 0px)",
                  transition: "width 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
                }}
              >
                <Route exact path="/" render={(match) => {
                  return <Homepage route={match} toggleNavigation={this.handleToggleNavigation}/>;
                }}/>
                <Route exact path="/editor" render={(match) => {
                  return <Editor route={match} toggleNavigation={this.handleToggleNavigation}/>;
                }}/>
                <Route path="/editor/:mode/:type/:id" render={(match) => {
                  return <Editor route={match} toggleNavigation={this.handleToggleNavigation}/>;
                }}/>
              </div>
            </div>
          </MuiThemeProvider>
        </BrowserRouter>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App/App.js